import classnames from 'classnames'

import styles from './index.css'

import type { FC, ReactNode } from 'react'

export type DrawerProps = {
  children?: ReactNode
  className?: string
  display?: 'fixed' | 'static'
  footer?: ReactNode
  header?: ReactNode
  isOpen?: boolean
  onClose?: () => void
  position?: 'left' | 'right'
}

const Drawer: FC<DrawerProps> = ({
  children,
  className,
  display = 'fixed',
  footer,
  header,
  isOpen,
  onClose,
  position = 'left',
}) => {
  const isOverlay = display === 'fixed'
  return (
    <>
      {isOverlay && isOpen && (
        <div className={styles.touch} onClick={onClose} onKeyDown={onClose} role="button" tabIndex={0} />
      )}
      <div
        className={classnames(
          'bg-background text-clip flex flex-col',
          isOverlay && !isOpen && styles.close,
          isOverlay && 'fixed',
          isOverlay && isOpen && styles.open,
          isOverlay && position === 'right' && styles.right,
          styles.wrapper,
          className,
        )}
        data-dark-mode="true"
      >
        <div className="shrink p-2 border-0 border-b border-b-greyLightMed border-solid">
          <div className="overflow-hidden">{header}</div>
        </div>
        <div className="grow overflow-y-auto overflow-x-hidden p-2">{children}</div>
        <div className="shrink p-2 border-0 border-t border-t-greyLightMed border-solid">
          <div className="overflow-hidden">{footer}</div>
        </div>
      </div>
    </>
  )
}

export default Drawer
